export const Addresses = {
    usdt: "0x55d398326f99059fF775485246999027B3197955",
    busd: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
    usdc: "0x55d398326f99059fF775485246999027B3197955",
    mintAddress: "0x3096615c50Af14E6CACCF663B1fA7c5CBC712D9d"
}
export const chainID = {
    id: 56
}